import { useTheme } from "app/shared";
import { FC } from "react";
import styles from "./Backers.module.scss";

interface BackersProps {
  backers: string[];
}

const Backers: FC<BackersProps> = ({ backers }) => {
  const { theme } = useTheme();
  return (
    <div
      className={`${styles.container} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <h2 className={styles.title}>Backers/Partners</h2>

      <div className={styles.badgesContainer}>
        {backers.map((backer, index) => (
          <span
            key={index}
            className={`${styles.badge} ${
              theme === "dark" ? styles.darkTheme : ""
            }`}
          >
            {backer}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Backers;
